/* Each FAQ owns its disclosure state. Native details keep answers usable without JavaScript. */
if (!customElements.get('park-faq')) {
  customElements.define('park-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.questions = [...this.querySelectorAll('[data-faq-question]')];
      this.limit = Number(this.dataset.initialCount) || 0;
      this.button = this.querySelector('[data-faq-more]');
      this.expanded = false;
      this.onMore = () => { this.expanded = !this.expanded; this.update(); };
      this.onToggle = event => {
        if (this.dataset.singleOpen !== 'true' || !event.target.open) return;
        this.questions.forEach(question => { if (question !== event.target) question.open = false; });
      };
      this.questions.forEach(question => question.addEventListener('toggle', this.onToggle));
      this.button?.addEventListener('click', this.onMore);
      this.update();
    }
    update() {
      const limited = this.limit > 0 && this.questions.length > this.limit;
      this.questions.forEach((question,index) => {
        question.hidden = limited && !this.expanded && index >= this.limit;
        if (question.hidden) question.open = false;
      });
      if (this.button) {
        this.button.hidden = !limited;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.textContent = this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
      }
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onMore);
      this.questions?.forEach(question => { question.removeEventListener('toggle', this.onToggle); question.hidden = false; });
      this.ready = false;
    }
  });
}
